import { useElf } from '../redux/reducer/elf'
import { useEffect, useState } from 'react'
import { importElfGameJS } from '../controllers/elf/items/import'
import { useElfStateControls } from './useElfStateControls'
import { useModal } from './useModal'
import { usePreviousStates } from '../redux/reducer/content'
import {
  CALLBACKS_AFTER_STATE_CHANGE,
  PROFILE_HELLO_DELAY,
  TOGGLE_VISIBLE_ELF_STATES,
  VISIBLE_ELF_STATES,
  VISIBLE_ROOM_STATES,
} from '../constants/components/scenes/elf/logic'
import { useApplicationCallbacks } from '../providers/application-callbacks'
import { isBoolean } from 'lodash'
import { useGiftMeInteractive } from './useGiftMeInteractive'

export const useElfLogic = () => {
  const { outsideActions } = useElf()
  const previousStates = usePreviousStates()
  const [wrapper, setWrapper] = useState()

  const callbacks = useApplicationCallbacks()
  const { modals } = useModal()

  const elfStates = useElfStateControls(wrapper)
  const updateGiftMeVisibility = useGiftMeInteractive()

  const entered = (state) => {
    updateGiftMeVisibility()
    const outsideAnimations = outsideActions.filter(
      ({ state: animationState }) => animationState === 'any' || state === animationState,
    )
    const enterAnimations =
      CALLBACKS_AFTER_STATE_CHANGE[state]?.map((animation) => ({ state, animation })) ?? []
    const totalAnimations = [...outsideAnimations, ...enterAnimations]

    callbacks.addAnimations(totalAnimations)
    callbacks.resetOutsideAnimations(state)
  }

  const exited = () => {
    callbacks.resetAnimation({ isAll: true })
    elfStates?.setIdle()
  }

  const enter = (state) => {
    callbacks.setIsVisibleRoom(VISIBLE_ROOM_STATES.includes(state))

    // Если состояние в VISIBLE_ELF_STATES, эльф должен быть видимым
    if (VISIBLE_ELF_STATES.includes(state)) {
      // Проверяем TOGGLE_VISIBLE_ELF_STATES - специальная логика для определенных состояний
      let shouldHide = false
      for (const { toggleState, condition } of TOGGLE_VISIBLE_ELF_STATES) {
        if (toggleState === state && !condition(previousStates)) {
          // Если состояние в TOGGLE_VISIBLE_ELF_STATES, но условие НЕ выполнено - скрываем
          // Например, для 'start': если previousStates включает 'share', то скрываем эльфа
          shouldHide = true
          break
        }
      }

      if (shouldHide) {
        callbacks.setIsVisible(false)
      } else {
        callbacks.setIsVisible(true)
      }
      return
    }

    // Если состояние НЕ в VISIBLE_ELF_STATES, скрываем эльфа
    callbacks.setIsVisible(false)
  }

  const isShowedModal = modals.some(({ type }) => type === 'profileModal')

  useEffect(() => {
    if (!elfStates || !isBoolean(isShowedModal)) return

    if (!isShowedModal) {
      exited()
      return
    }

    callbacks.setIsVisible(false)

    const animationTimeout = setTimeout(() => {
      callbacks.addAnimations([
        {
          state: 'any',
          animation: 'hello',
        },
      ])
    }, PROFILE_HELLO_DELAY)

    return () => clearTimeout(animationTimeout)
  }, [isShowedModal, elfStates])

  useEffect(() => {
    ;(async () => {
      const { wrapper } = await importElfGameJS()
      setWrapper(wrapper)
    })()
  }, [])

  return { entered, exited, enter }
}
